import { set } from "lodash";
import styled from "styled-components";
import { debounce } from "lodash";
export const CustomLabel = styled.label`
  font-size: ${(props) => (props.font_size ? props.font_size : "16")}px;
  font-weight: ${(props) => (props.font_weight ? props.font_weight : "bold")};
  color: ${(props) => (props.color ? props.color : "black")};
  @media (max-width: 767px) {
    font-size: ${(props) => (props.font_size ? props.font_size - 3 : "12")}px;
  }
`;

export const Wrapper = styled.section`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: black;
  object-fit: contain;
  margin-bottom: 40px;
  font-family: Arial;
`;

export const maskedMailed = (email) => {
  return email.replace(
    /^(.)(.*)(.@.*)$/,
    (_, a, b, c) => a + b.replace(/./g, "*") + c
  );
};

export const maskPhoneNumber = (mobileNo) => {
  mobileNo = mobileNo.toString();
  let maskNumber = "*******";
  const strMob = mobileNo.slice(8, 10);
  maskNumber = maskNumber + strMob;
  return maskNumber;
};

export const validation_Of_Payment = ({ paymentDate }) => {
  // if (!paymentDate) return true
  // let dateMomentObject = moment(renewalDate, "DD/MM/YYYY").format("DD/MM/YYYY");
  // dateMomentObject = moment(dateMomentObject.toString(), "DD/MM/YYYY");
  // renewalDate = dateMomentObject.toDate();
  // const presentDate = new Date();
  // const diffTime = renewalDate - presentDate;
  // const diffDays = Math.ceil(diffTime / one_day);
  // let d = new Date(renewalDate).getTime() + 30 * one_day;
};

export const error_message = {
  common_error:
    "We are facing some issue at the moment, please try after some time.",
  pancard_error: "Please Enter Mandatory Pancard Number / In Correct Format",
  policy_input_error: "Please Enter Valid Policy Number",
  date_input_error: "Please Enter Valid Date Of Birth",
  tnc_error: "Please check the terms and conditions",
  Invalid_Otp: "You had enter invalid OTP",
  download_error: "Please Enter either policy number or date range",
};

export const regex = {
  numeric_only: /[^0-9]/g,
  decimal_only: /[^.0-9]/g,
  alphaNumeric: /[^a-zA-Z0-9[/]]/g,
  alpha: /[^a-zA-Z]/g,
  PAncard: /[A-Z]{3}[PCHFATBLJG]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}?$/,
  emailValidation: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
  name: /[^a-zA-Z ]/g,
  common: /[^a-zA-Z0-9.@_ ]/g,
};

export const TYPE_OF_VALIDATION = {
  email: "EMAIL",
  Mobile: "MOBILE",
  pancard: "PANCARD",
  AgenNo: "AgentNo",
};

export const payment_option = [
  { name: "Premium Payment", value: "Premium payment" },
  { name: "Deficit Payment", value: "Deficit" },
  { name: "Loading Payment", value: "Loading" },
  { name: "Installment Payment", value: "Instalment" },
];

export const payment_option_only_asba = [
  { name: "UPI - ASBA", value: "UPI_ASBA" },
];

export const payment_option_with_upi = [
  { name: "Premium Payment", value: "Premium payment" },
  { name: "Deficit Payment", value: "Deficit" },
  { name: "Loading Payment", value: "Loading" },
  { name: "Installment Payment", value: "Instalment" },
  // { name: "UPI - ASBA", value: "UPI_ASBA" },
];

/**
         With HRP Receipt
        With HMB Receipt
        With HRP & HMB Receipt
        Member Addition
        Member deletion
        Floater to Multi Individual
        SI Increase
        SI Decrease
        Rider Addition
        Proposer Change
        After Grace-end
        Agent Change Request
        Split Policy – Child Policy Renewal Receipt

 */

export const reason_for_quickpay = [
  { name: "With HRP Receipt", value: "With HRP Receipt" },
  { name: "With HMB Receipt", value: "With HMB Receipt" },
  { name: "With HRP & HMB Receipt", value: "With HRP & HMB Receipt" },
  { name: "Member Addition", value: "Member Addition" },
  { name: "Member deletion", value: "Member deletion" },
  { name: "Floater to Multi Individual", value: "Floater to Multi Individual" },
  { name: "Rider Addition", value: "Rider Addition" },
  { name: "Rider Deletion ", value: "Rider Deletion" },
  { name: "SI Increase", value: "SI Increase" },
  { name: "SI Decrease", value: "SI Decrease" },
  { name: "Proposer Change", value: "Proposer Change" },
  { name: "After Grace-end", value: "After Grace-end" },
  { name: "Agent Change Request", value: "Agent Change Request" },
  { name: "Split Policy – Child Policy Renewal Receipt", value: "Split Policy – Child Policy Renewal Receipt" },
  { name: "Change in Zone ", value: "Change in Zone" },
  { name: "Change in Personal Information / DOB", value: "Change in Personal Information / DOB" },
  { name: "Change in Product", value: "Change in Product" },
  { name: "Change in Payment Frequency ", value: "Change in Payment Frequency" },
  { name: "Premium Mismatch", value: "Premium Mismatch" },
  { name: "DEA Renewal QuickPay", value: "DEA Renewal QuickPay" },
  { name: "Others", value: "Others" },
];
export const DEA_RENEWAL_QUICKPAY_CONSTANT = "DEA Renewal QuickPay";
export const format_amount = (amount) => {
  if (
    amount.toString().includes(".") ||
    amount.toString().split(".")[0].length >= 9
  ) {
    amount.toString().split(".")[0] = amount
      .toString()
      .split(".")[0]
      .slice(0, 9);
    return `${amount.toString().split(".")[0]}.${amount
      .toString()
      .split(".")[1]
      .slice(0, 2)}`;
  }
  if (amount.toString().length > 9) {
    return amount.toString().slice(0, 9);
  }

  return amount;
};

export const Agent_optiom = [
  { name: "Agent Recruitment Fee", value: "Agent Recruitment Fee" },
];

export const validationOfField = (type, value) => {
  switch (type) {
    case TYPE_OF_VALIDATION.email:
      if (regex.emailValidation.test(value)) {
        return false;
      }
      return true;
    case TYPE_OF_VALIDATION.Mobile:
      if (value.length === 10) {
        return false;
      }
      return true;
    case TYPE_OF_VALIDATION.pancard:
      if (regex.PAncard.test(value)) {
        return false;
      }
      return true;
    case TYPE_OF_VALIDATION.AgenNo:
      if (value.length === 12) {
        return false;
      }
      return true;
  }
};

export const TOKEN_MIS_DUMP = "token-misdump";
export const TYPE_OF_USER = "TYPE_OF_USER";

export const getURlParameter = (param, decodedURI) => {
  let sPageURl = decodedURI || window.location.search.substring(1);
  let sURLVriable = sPageURl.split("&");
  for (var i = 0; i < sURLVriable.length; i++) {
    let sParameterName = sURLVriable[i].split("=");
    if (sParameterName[0] == param) return sParameterName[1];
  }
};

export const ruppeeConverter = (ruppee) => {
  if (!ruppee) return "0.00";
  ruppee = ruppee.toString();
  var newArr = ruppee.split(".");
  var strArr1 = ruppee.split(".")[0].split("");
  switch (newArr[0].length) {
    case 4:
    case 5:
      strArr1.splice(-3, 0, ",");
      newArr[0] = strArr1.join("");
      ruppee = newArr.join(".");
      break;
    case 6:
    case 7:
      strArr1.splice(-3, 0, ",");
      strArr1.splice(-6, 0, ",");
      newArr[0] = strArr1.join("");
      ruppee = newArr.join(".");
      break;
    case 8:
    case 9:
      strArr1.splice(-3, 0, ",");
      strArr1.splice(-6, 0, ",");
      strArr1.splice(-9, 0, ",");
      newArr[0] = strArr1.join("");
      ruppee = newArr.join(".");
      break;
  }

  return ruppee;
};
